module.exports = __webpack_public_path__ + "icofont.529c3ac7a75675f5a949.ttf";


//////////////////
// WEBPACK FOOTER
// D:/Angular projects/memberreg/memberreg/src/assets/icon/icofont/fonts/icofont.ttf?v=1.0.0-beta
// module id = ../../../../../src/assets/icon/icofont/fonts/icofont.ttf?v=1.0.0-beta
// module chunks = styles